import PatientInfo from './PatientInfo';
export default PatientInfo;
